<template>
    <a :href="'/Payment/'+row.GroupCode" target="_blank">{{row.GroupCode}}</a>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{

    }
}
</script>